import { render, staticRenderFns } from "./AMLCheck.vue?vue&type=template&id=4ae720ad&"
import script from "./AMLCheck.vue?vue&type=script&lang=js&"
export * from "./AMLCheck.vue?vue&type=script&lang=js&"
import style0 from "./AMLCheck.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports